<template>
    <div class="address_drawer_content">
        <div style="padding-bottom:10px;float: right;">
            <el-button type="primary" @click="addAddress" style="width: 100px;">新增地址</el-button>
        </div>
        <el-table :data="addressArr" max-height="750" @row-click="rowClick">
            <el-table-column align="center" label="选择" width="80">
                <template slot-scope="scope">
                    <el-radio :label="scope.row.tableId" v-model="tableRadio">&nbsp;</el-radio>
                </template>
            </el-table-column>
            <el-table-column property="contactName" label="联系人" width="150"></el-table-column>
            <el-table-column property="phoneNumber" label="手机号" width="200"></el-table-column>
            <el-table-column property="address" :label="addressLabel">
                <template slot-scope="scope">
                    <span v-if="scope.row.province === ''">{{scope.row.contactAddress}}</span>
                    <span v-if="scope.row.province !== ''">{{scope.row.province}}/{{scope.row.city}}/{{scope.row.county}}/{{scope.row.street}}/{{scope.row.contactAddress}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="address_drawer_footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit">确 认</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AddressSelectDrawer',
        props: {
            addressType: {
                type: String,
                default: 'delivery'
            },
            tableIndex: {
                type: Number,
                default: -1
            },
            addressList: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                addressLabel: '',
                addressArr: this.addressList,
                tableRadio: -1,
            }
        },
        mounted() {
            this.tableRadio = this.tableIndex;
            if (this.addressType === 'bill') {
                this.addressLabel = '账单地址';
            } else {
                this.addressLabel = '联系地址';
            }
        },
        watch: {
            addressType() {
                if (this.addressType === 'bill') {
                    this.addressLabel = '账单地址';
                } else {
                    this.addressLabel = '联系地址';
                }
            },
            tableIndex() {
                this.tableRadio = this.tableIndex;
            },
            addressList: {
                deep: true,
                handler() {
                    this.tableRadio = this.addressList.findIndex(item => item.main);
                    this.addressArr = this.addressList;
                }
            }
        },
        methods: {
            rowClick(row) {
                this.tableRadio = row.tableId;
            },
            close() {
                this.tableRadio = -1;
                this.$emit('addressSelectClose', true);
            },
            submit() {
                this.$emit('addressSelectSubmit', this.addressArr[this.tableRadio]);
            },
            addAddress() {
                this.$emit('addAddressShow', true);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .address_drawer_content {
        margin: 0 20px;
    }
    .address_drawer_footer {
        position: absolute;
        display: flex;
        bottom: 20px;
        width: calc(100% - 40px);
        box-sizing: border-box;
        .el-button {
            width: 50%;
            height: 40px;
            font-weight: 400;
            font-size: 16px;
        }
    }
</style>